import moment from 'moment';
import i18n from 'l10n';
import Chart from 'chartjs';
import ch from 'libs/chart-helpers';
import Handlebars from 'handlebars';

    var it={};
    var toText = function(n, len) {
        if(!len) len = 4;
        var text = "" + n;
        if(text.length <= len) return text;
        else return "<small>"+text+"</small>";
    };

    var queryOptions = {
        from: null, //long millis
        to: null, //long millis
        unit: "day",
        dow: null //first day of week (0-Sunday ...)
    };
    it.options = {
        from: null, //moment
        to: null, //moment
        window: null,
        queryOptions: queryOptions
    };

    it.options.from = moment().startOf('day').subtract(6,'days');
    it.options.to= moment().endOf('day');

    var startOf = it.options.from.clone();
    it.options.queryOptions.from = startOf.toDate().getTime();
    var endOf = it.options.to.clone();
    it.options.queryOptions.to = endOf.toDate().getTime();

    var last7days = i18n.labels7ConsecutiveDays(moment());
    var currentlocaleData = moment().localeData();

    it.init = function(tileSelector, chartSelector) {

        if (i18n.language === "el") {
            $("#tellody-blog").attr("href", "https://www.tellody.com/el/marketing-automation-2");
            $("#automation").attr("href", "https://www.tellody.com/el/blog-2");
        }

        var handlerBlocked = function(json) {
            $(tileSelector).find("#blocked-count").text(json);
            var cl = Handlebars.helpers.dynamicFontSize(json, $(tileSelector).find("#blocked-count").data("font-length"));
            $(tileSelector).find("#blocked-count").addClass(cl.toString());
            $(tileSelector).find("#contact-blocked-title").text(i18n.t("message.optouts", {count: json}));
        };
        $.getDefaultJSONQ('/CampaignCloud/Group/1/count', null, handlerBlocked);

        var handlerGroupCounter = function(json) {
            $(tileSelector).find("#group-count_1").show().text(json);
            var cl = Handlebars.helpers.dynamicFontSize(json, $(tileSelector).find("#group-count_1").data("font-length"));
            $(tileSelector).find("#group-count_1").addClass(cl.toString());
            $(tileSelector).find("#group-text").text(i18n.t("dashboard.groups", {count: json}));

        };
        $.getDefaultJSONQ('/CampaignCloud/Group/countGroups', null, handlerGroupCounter);

        // $.getDefaultJSONQ('/CampaignCloud/Subscription/count', null, handler);

        var handler = function() {
            return $.ajaxDefaultQ({
                url: "/CampaignCloud/Subscription/count",
                type: 'GET',
                dataType: "json"
            }).done(function(json) {
                $(tileSelector).find("#contact-count_1").show().text(json);
                var cl = Handlebars.helpers.dynamicFontSize(json, $(tileSelector).find("#contact-count_1").data("font-length"));
                $(tileSelector).find("#contact-count_1").addClass(cl.toString());
                $(tileSelector).find("#contact-text").text(i18n.t("dashboard.contacts", {count: json}));
            }).fail(function(response){
                console.log(response);
            });

        };

        var handler4 = function() {
            return $.ajaxDefaultQ({
                url: '/CampaignCloud/Report/LastWeekOptoutsNewContacts',
                type: 'GET',
                contentType: 'application/json',
                dataType: 'json'
            }).done(function(json) {
                var newContactsLastWeekCount = 0;
                var newGroups = json.newGroupsLastWeek[0];
                for (var i = 0; i < json.newContactsLastWeek.length; i++) {
                    newContactsLastWeekCount = newContactsLastWeekCount+ json.newContactsLastWeek[i];
                }

                const updateElements = (a, b) => {
                    a.text(b);
                    const cl = Handlebars.helpers.dynamicFontSize(b, a.data("font-length"));
                    a.addClass(cl.toString());
                };

                json.newContactsLastWeekCount = newContactsLastWeekCount;

                const $contactsLastWeek = $(".contactsLastWeek");
                updateElements($contactsLastWeek, newContactsLastWeekCount);

                $(".contactsLastWeekText").text(i18n.t("dashboard.newContact", {count: newContactsLastWeekCount}));

                $(chartSelector).find("#newGroupsLastWeek").show().text(newGroups);
                let cl = Handlebars.helpers.dynamicFontSize(newGroups, $(tileSelector).find("#newGroupsLastWeek").data("font-length"));
                $(tileSelector).find("#newGroupsLastWeek").addClass(cl.toString());
                $('#this-week-area').find("#group-text-last-week").text(i18n.t("dashboard.groups", {count: newGroups}));

                var data = {
                    labels: last7days,
                    datasets: [
                        {
                            label: i18n.t('reports.newcontactslabel'),
                            fillColor: ch.colors.mauveUno.transparent,
                            strokeColor: ch.colors.mauveUno.solid,
                            pointColor: ch.colors.mauveUno.solid,
                            pointStrokeColor: "#fff",
                            pointHighlightFill: "#fff",
                            pointHighlightStroke: ch.colors.mauveUno.solid,
                            data: json.newContactsLastWeek
                        },
                        {
                            label: i18n.t('reports.optoutlabel'),
                            fillColor: ch.colors.blueDue.transparent,
                            strokeColor: ch.colors.blueDue.solid,
                            pointColor: ch.colors.blueDue.solid,
                            pointStrokeColor: "#fff",
                            pointHighlightFill: "#fff",
                            pointHighlightStroke: ch.colors.blueDue.solid,
                            data: json.blockedContactsLastWeek
                        }
                    ]
                };
                var options = {
                    legendTemplate:  "<% for (var i=0; i<datasets.length; i++){%><span class=\"chartContentInfo\"><span style=\"background-color:<%=datasets[i].strokeColor%>; width:15px; height:10px; display:inline-block\"></span><%if(datasets[i].label){%> <%=datasets[i].label%><%}%></span><%}%><br/><div style=\"align:center\"><a id=\"export-clicks-code\" class=\"export-button\"><span id=\"export-contacts-title\"></span></a></div>",
                    bezierCurve : false,
                    responsive: true,
                    datasetFill : false

                };


                var ctx = $(chartSelector).find("#contact-optout-line-chart").get(0).getContext("2d");
                var myLineChart = new Chart(ctx).Line(data, options);
                var legend = myLineChart.generateLegend();

                $(chartSelector).find('#clicksInfoTable').html(legend).find('#export-clicks-code').click(function(){
                    var encodedUri = ch.exportHandler(myLineChart);
                    $('#export-clicks-code').attr({'href':encodedUri, 'download':'chart_data.txt', 'id':'export-clicks-code'});
                    $('#export-contacts-title').text(i18n.t("dashboard.export"));
                }).click();

            }).fail(function(response){
                console.log(response);
            });

        };

        $.when(handler(), handler4()).done(function(a1, a2){
            var countOfContacts = a1[0];
            var contactsOfLastWeek = a2[0].newContactsLastWeekCount;
            var increase = countOfContacts - (countOfContacts-contactsOfLastWeek);
            var percentage = 0;
            if(countOfContacts-contactsOfLastWeek !== 0) {
                percentage = ((increase/(countOfContacts-contactsOfLastWeek))*100).toFixed(0);
            } else {
                percentage = increase*100;
            }
            $('#increace-contacts-percentage').text(percentage + "%");
            var pb = $("#increace-contacts-bar").progressbar();
            if(percentage > 100) {
                pb.progressbar('value', 100);
            } else {
                pb.progressbar('value', percentage);
            }
        });

        $.ajaxDefaultQ({
            url: '/CampaignCloud/ApiUser/Redeemers/count',
            type: 'GET',
            dataType: 'json'
        }).done(function(count) {
            $("#redeemers-title").text(i18n.t("dashboard.redeemersTitle",{count:count}));
            $("#redeemers-text").text(count);
            $("#redeemersDiv").show();
        });

    };

    export default it;

